import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring } from "remotion";
import React from "react";

// VFX: Chapter Title Card
// Category: intros-outros · Tags: outro, chapter, title, card, section
const ChapterTitle: React.FC<{
  chapterNumber?: number; title?: string; subtitle?: string; accentColor?: string;
}> = ({ chapterNumber = 1, title = "Introdução", subtitle = "O que você vai aprender", accentColor = "#a855f7" }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const numSp = spring({ frame, fps, config: { stiffness: 150, damping: 22 } });
  const titleSp = spring({ frame: frame - 10, fps, config: { stiffness: 120, damping: 20 } });
  const subSp = spring({ frame: frame - 18, fps, config: { stiffness: 100, damping: 20 } });
  return (
    <AbsoluteFill style={{
      background: "linear-gradient(180deg, #0a0e1a 0%, #1e293b 100%)",
      alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16
    }}>
      <div style={{ transform: `scale(${numSp})`, opacity: numSp }}>
        <span style={{ fontSize: 18, fontWeight: 700, color: accentColor, letterSpacing: "0.4em", textTransform: "uppercase" }}>
          Capítulo {String(chapterNumber).padStart(2, "0")}
        </span>
      </div>
      <div style={{ width: 64, height: 2, background: accentColor, opacity: titleSp, transform: `scaleX(${titleSp})` }} />
      <p style={{
        margin: 0, fontSize: 88, fontWeight: 900, color: "#f8fafc", textAlign: "center",
        opacity: titleSp, transform: `translateY(${(1 - titleSp) * 24}px)`
      }}>{title}</p>
      <p style={{
        margin: 0, fontSize: 28, color: "#94a3b8", textAlign: "center",
        opacity: subSp, transform: `translateY(${(1 - subSp) * 16}px)`
      }}>{subtitle}</p>
    </AbsoluteFill>
  );
};

export default function CtaChapterTitleCard1000Ms() {
  return <ChapterTitle chapterNumber={1} title="Introdução" subtitle="O que você vai aprender" />;
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
